import { AppBar, Toolbar } from "@mui/material";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {useSharedLang} from '../hooks/useSharedLang.js'
import i18n from "i18next";
import {LANGS } from "../components/constants.js";

const HeaderHome = () => {
    const { t } = useTranslation();
    const { sharedLang , setSharedLang } = useSharedLang();

    const setLang = (event) => {
        let lang = event.target.value
        setSharedLang(lang);
        i18n.changeLanguage(lang);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
        <header>
        <AppBar elevation={0} position="static">
            <Toolbar 
                variant="dense" 
                disableGutters 
                sx={{ paddingRight:"5px",display: "flex", justifyContent: "space-between" }}
            >
                <Typography className={`header-left ${sharedLang}`}></Typography>
                <Typography className="header-title">{t("home.app_title1")}{t("home.app_title2")}</Typography>
                <Select
                    id="lang-select"
                    value={sharedLang}
                    onChange={setLang}
                    sx={{
                        color: "white",
                        '.MuiOutlinedInput-notchedOutline': {
                          borderColor: '#BA1D0B',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#BA1D0B',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#BA1D0B',
                        },
                        '.MuiSvgIcon-root ': {
                          fill: "#BA1D0B !important",
                        }
                      }}
                    >
                    <MenuItem value={`${LANGS.JAPANESE}`}>JP</MenuItem>
                    <MenuItem value={`${LANGS.ENGLISH}`}>EN</MenuItem>
                </Select>
            </Toolbar>
        </AppBar>
        </header>
        </Box>
    );

};
export default HeaderHome